import React from 'react';
import Header from '../common/Header';
import PresentationComp from './PresentationComp';
import DownloadComp from './DownloadComp';
import PartnersComp from './PartnersComp';
import AdvantagesComp from './AdvantagesComp';
import NewPartnerComp from './NewPartnerComp';
import Footer from '../common/Footer';
import '../Public.scss';

const HomepageView = ({history}) => {
  return (
    <div className="homepage-section">
      <Header history={history}/>
      <PresentationComp />
      <AdvantagesComp />
      <DownloadComp />
      <PartnersComp />
      <NewPartnerComp />
      <Footer />
    </div>
  );
};

export default (HomepageView);
